<template>
  <div class="course-programs inline-replacement">
    <weui-group type="checkbox">
      <weui-checkbox v-for="p in programs" :key="p.id" v-model="p.checked">
        <p :class="{ 'text-primary': draft.programs.indexOf(p.id) >= 0 }">{{ p.name }}</p>
      </weui-checkbox>
    </weui-group>
    <weui-button-area>
      <weui-button type="primary" @click="savePrograms">设置</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { WeuiGroup, WeuiCheckbox, WeuiButtonArea, WeuiButton } from '@/components/weui';

import PROGRAMS from '@/constants/programs';
import { COURSE_DRAFT_FILL } from '@/store/course/types';

const { mapState, mapMutations } = createNamespacedHelpers('course');

export default {
    data() {
        const programs = PROGRAMS.map(p => ({
            ...p,
            checked: false,
        }));

        return {
            programs,
        };
    },
    computed: {
        ...mapState({
            draft: state => state.draft,
        }),
    },
    mounted() {
        this.draft.programs.forEach((pid) => {
            const program = this.programs.find(p => p.id === pid);
            if (program) {
                program.checked = true;
            }
        });
    },
    methods: {
        ...mapMutations({
            fillDraft: COURSE_DRAFT_FILL,
        }),
        savePrograms() {
            const programs = this.programs.filter(p => p.checked).map(p => p.id) || [];
            this.fillDraft({
                programs,
            });
            this.$router.go(-1);
        },
    },
    components: {
        WeuiGroup,
        WeuiCheckbox,
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/course/Programs.vue